//#region src/core/ui/dialog/data.ts
const DialogDataAttrs = {
	/** Present when the dialog is open. */
	open: "data-open",
	/** Present during the open transition. */
	transitionStarting: "data-starting-style",
	/** Present during the close transition. */
	transitionEnding: "data-ending-style"
};
//#endregion
export { DialogDataAttrs };

//# sourceMappingURL=data.js.map